<template>
  <div class="sign-in" v-if="isShow">
    <div class="row-img">
      <img src="../../assets/sign/q1.png" alt="" />
    </div>
    <div class="row-img">
      <img src="../../assets/sign/02.jpg" alt="" />
      <div class="sign-content">
        <div class="sign-btn">
          <img src="../../assets/sign/qiandao.png" class="btn" @click="signInOpen" />
        </div>
        <div class="sign-day">您已签到 {{ sign_day }} 天</div>
      </div>
    </div>
    <div class="row-img">
      <img src="../../assets/sign/6fcd75780928c38c004f7cba95e5a94f.jpg" alt="" />
      <div class="sign-content" style="bottom: 12%">
        <div class="sign-btn">
          <img src="../../assets/sign/bangding.png" class="btn" @click="bindOpen" />
        </div>
        <div class="sign-day">累计签到 {{ total_sign_days }} 天</div>
      </div>
      <div class="receive-btn" style="bottom: 70%">
        <img src="../../assets/sign/zidong.png" class="btn" />
      </div>
      <div class="receive-btn" style="bottom: 57%">
        <img
          v-if="total_sign_days >= 10 && is_reward_10 == 0"
          class="btn"
          src="../../assets/sign/lingqu.png"
          @click="totalSignDay"
        />
        <img
          v-else-if="total_sign_days >= 10 && is_reward_10 == 1"
          class="btn"
          src="../../assets/sign/yilingqu.png"
        />
        <img v-else src="../../assets/sign/wei.png" class="btn" />
      </div>
      <div class="receive-btn" style="bottom: 43.5%">
        <img
          v-if="total_sign_days >= 15 && is_reward_15 == 0"
          class="btn"
          src="../../assets/sign/lingqu.png"
          @click="getSign15"
        />
        <img
          v-else-if="total_sign_days >= 15 && is_reward_15 == 1"
          class="btn"
          src="../../assets/sign/yilingqu.png"
        />
        <img v-else src="../../assets/sign/wei.png" class="btn" />
      </div>
      <div class="receive-btn" style="bottom: 31%">
        <img
          v-if="total_sign_days >= 25 && is_reward_25 == 0"
          class="btn"
          src="../../assets/sign/lingqu.png"
          @click="getSign25"
        />
        <img
          v-else-if="total_sign_days >= 25 && is_reward_25 == 1"
          class="btn"
          src="../../assets/sign/yilingqu.png"
        />
        <img v-else src="../../assets/sign/wei.png" class="btn" />
      </div>
    </div>
    <div class="row-img">
      <img src="../../assets/sign/05.jpg" alt="" />
    </div>

    <!-- 绑定界面 -->
    <div class="modal-box" v-if="signInFrame">
      <div class="popup">
        <div class="close">
          <div class="icon" @click="signInClose"></div>
        </div>
        <div class="input">
          <div class="title">游戏ID</div>
          <input type="number" v-model="role_id" />
        </div>
        <div class="confirm">
          <img src="../../assets/sign/queren.png" class="btn" @click="confirm" v-if="!isLogin" />
        </div>
      </div>
    </div>

    <!-- 签到成功 -->
    <div class="success-box" v-if="signInSUC">
      <div class="popup popup02">
        <div class="close">
          <div class="icon" @click="signInSUC = false"></div>
        </div>
        <div class="confirm">
          <div class="btn" @click="signInSUC = false"></div>
        </div>
      </div>
    </div>

    <!-- 绑定成功 -->
    <div class="success-box" v-if="bindSUC">
      <div class="popup">
        <div class="close">
          <div class="icon" @click="bindSUC = false"></div>
        </div>
        <div class="confirm">
          <div class="btn" @click="bindSUC = false"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script scoped>
import { Toast } from 'vant'
import { getCheckWxLogin, getBindRole, getSign } from '@/api'
export default {
  data() {
    return {
      isShow: false,
      signInFrame: false,
      role_id: '',
      sign_day: 0,
      total_sign_days: 0,
      is_reward_10: 0,
      is_reward_15: 0,
      is_reward_25: 0,
      isLogin: false,

      signInSUC: false,
      bindSUC: false
    }
  },
  created() {
    this.getIsLogin()
  },
  methods: {
    //
    async getIsLogin() {
      let CODE = ''
      // let URL = 'http://u.zhankun.com/server/index.html#/signIn&code=58dfgfdx7362&type=ddfd232'
      let URL = window.location.href
      let num = URL.indexOf('code')
      if (num > -1) {
        let newStr = URL.slice(num + 5, URL.length - 1)
        if (newStr.indexOf('&') > -1) {
          CODE = newStr.slice(0, newStr.indexOf('&'))
        } else {
          CODE = newStr
        }
      }
      console.log('CODE: ', CODE)
      const res = await getCheckWxLogin({
        code: CODE
      })
      const { code, data, msg } = res.data
      if (code == 1000) {
        this.isShow = true
        this.sign_day = Number(data.sign_day)
        this.is_reward_10 = data.is_reward_10
        this.is_reward_15 = data.is_reward_15
        this.is_reward_25 = data.is_reward_25
        this.total_sign_days = Number(data.total_sign_days)
        this.role_id = data.role_id ? data.role_id : ''
        if (this.role_id) {
          this.isLogin = true
        }
      }
      if (code == 5002) {
        // console.log('data: ', data.wx_redirect_url)
        window.location.href = data.wx_redirect_url
      }
    },
    async signInOpen() {
      if (this.isLogin) {
        // setTimeout(() => {
        //   this.signInSUC = true
        //   this.sign_day = this.sign_day + 1
        //   if (this.sign_day > 7) {
        //     this.sign_day = 1
        //   }
        //   this.total_sign_days = this.total_sign_days + 1
        // }, 2000)
        const res = await getSign({
          type: 1
        })
        const { code, msg } = res.data
        if (code == 1000) {
          // Toast('签到成功')
          this.signInSUC = true
          this.sign_day = this.sign_day + 1
          if (this.sign_day > 7) {
            this.sign_day = 1
          }
          this.total_sign_days = this.total_sign_days + 1
        } else {
          Toast(msg)
        }
      } else {
        this.signInFrame = true
      }
    },
    signInClose() {
      this.signInFrame = false
    },
    bindOpen() {
      this.signInFrame = true
    },
    async confirm() {
      if (!this.role_id) {
        Toast('请输入游戏ID')
        return
      }
      if (this.role_id.length < 14) {
        Toast('角色ID必须是14位及以上纯数字，请在游戏内获取正确的角色id，非登录账号')
        return
      }
      // setTimeout(() => {
      //   this.isLogin = true
      //   this.signInFrame = false
      //   this.bindSUC = true
      // }, 2000)
      const res = await getBindRole({
        role_id: this.role_id
      })
      const { code, msg } = res.data
      if (code == 1000) {
        // Toast(msg)
        this.isLogin = true
        this.signInFrame = false
        this.bindSUC = true
      } else {
        Toast(msg)
      }
    },
    async totalSignDay() {
      // setTimeout(() => {
      //   this.is_reward_10 = 1
      // }, 2000);
      const res = await getSign({
        type: 2
      })
      const { code, msg } = res.data
      if (code == 1000) {
        Toast('领取成功')
        this.is_reward_10 = 1
      } else {
        Toast(msg)
      }
    },
    async getSign15() {
      const res = await getSign({
        type: 3
      })
      const { code, msg } = res.data
      if (code == 1000) {
        Toast('领取成功')
        this.is_reward_15 = 1
      } else {
        Toast(msg)
      }
    },
    async getSign25() {
      const res = await getSign({
        type: 4
      })
      const { code, msg } = res.data
      if (code == 1000) {
        Toast('领取成功')
        this.is_reward_25 = 1
      } else {
        Toast(msg)
      }
    }
  }
}
</script>

<style scoped lang="less">
.sign-in {
  display: inline-block;
  max-width: 500px;
  .row-img {
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
      margin: -1px 0;
    }
    .sign-content {
      position: absolute;
      bottom: 14%;
      left: 0;
      width: 100%;
      text-align: center;
      .sign-btn {
        .btn {
          width: 68%;
          height: 65px;
          display: inline-block;
          text-align: center;
        }
      }
      .sign-day {
        padding-top: 5px;
        font-size: 20px;
        color: #c4a551;
      }
    }
    .receive-btn {
      position: absolute;
      bottom: 36%;
      left: 0;
      width: 100%;
      text-align: right;
      .btn {
        display: inline-block;
        width: 98px;
        height: 40px;
        margin-right: 7%;
      }
    }
  }
  .modal-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    padding-top: 80px;
    background-color: rgba(0, 0, 0, 0.2);
    .popup {
      position: relative;
      width: 80%;
      max-width: 500px;
      height: 53%;
      display: inline-block;
      background-color: #ccc;
      background: url('../../assets/sign/k01.jpg') no-repeat;
      background-size: 100% 100%;
      .close {
        text-align: right;
        .icon {
          display: inline-block;
          width: 55px;
          height: 55px;
        }
      }
      .input {
        box-sizing: border-box;
        position: absolute;
        top: 20%;
        left: 0;
        text-align: center;
        width: 100%;
        display: flex;
        padding-left: 36px;
        .title {
          height: 45px;
          line-height: 45px;
          color: #c4a551;
          font-weight: 600;
          padding-right: 10px;
        }
        input {
          border: none;
          width: 70%;
          height: 45px;
        }
      }
      .confirm {
        width: 100%;
        position: absolute;
        top: 35%;
        left: 0;
        text-align: center;
        .btn {
          display: inline-block;
          width: 120px;
          height: 40px;
        }
      }
    }
  }

  .success-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    padding-top: 80px;
    background-color: rgba(0, 0, 0, 0.2);
    .popup {
      position: relative;
      width: 80%;
      max-width: 500px;
      height: 210px;
      display: inline-block;
      background-color: #ccc;
      background: url('../../assets/sign/s1.png') no-repeat;
      background-size: 100% 100%;
      .close {
        text-align: right;
        .icon {
          display: inline-block;
          width: 65px;
          height: 65px;
        }
      }
      .confirm {
        width: 100%;
        position: absolute;
        top: 58%;
        left: 0;
        text-align: center;
        .btn {
          display: inline-block;
          width: 150px;
          height: 50px;
          // background-color: red;
        }
      }
    }
    .popup02 {
      background: url('../../assets/sign/s2.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
